import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { fetchMemos } from 'catalog/actions/memo';
import { createEntityNode } from 'catalog/actions/node';
import NodeSourcePage from './NodeSourcePage';

const mapStateToProps = state => ({
  entities: state.catalog.memos,
  info:
    'Sélectionnez un mémo technique pour créer un noeud à partir de ce dernier.',
  link: '/memos/new',
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchEntities: () => dispatch(fetchMemos()),
  createNode: memo =>
    dispatch(
      createEntityNode(ownProps.catalog, ownProps.params.id, 'memo', memo)
    ),
  redirectToParent: () => dispatch(replace(`/nodes/${ownProps.params.id}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NodeSourcePage);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodeMemosPage.js